import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/template/index.scss";
import "./assets/Admin/global.scss";
import "./assets/responsive.scss";

import { Route, Routes } from "react-router-dom";

import AdminRoute from "./utils/security/AdminRoute";
import AuthContext from "./context/auth_context";
import AwardAdd from "./pages/AwardAdd";
import AwardOrder from "./pages/AwardOrder";
import AwardList from "./pages/AwardList";
import BlogAdd from "./pages/BlogAdd";
import BlogList from "./pages/BlogList";
import CategoryProductAdd from "./pages/CategoryProductAdd";
import CategoryProductList from "./pages/CategoryProductList";
import CompanyAdd from "./pages/CompanyAdd";
import CompanyList from "./pages/CompanyList";
import CountryAdd from "./pages/CountryAdd";
import CountryList from "./pages/CountryList";
import CustomerAdd from "./pages/CustomerAdd";
import CustomerList from "./pages/CustomerList";
import Dashboard from "./pages/Dashboard";
import EducationAdd from "./pages/EducationAdd";
import EducationCategoryAdd from "./pages/EducationCategoryAdd";
import EducationCategoryList from "./pages/EducationCategoryList";
import EducationList from "./pages/EducationList";
import PromotionList from "./pages/PromotionList";
import PromotionAdd from "./pages/PromotionAdd";
import ErrorPage from "./pages/ErrorPage";
import GalleryAdd from "./pages/GalleryAdd";
import GalleryList from "./pages/GalleryList";
import LessonAdd from "./pages/LessonAdd";
import LessonList from "./pages/LessonList";
import LevelAdd from "./pages/LevelAdd";
import LevelList from "./pages/LevelList";
import Login from "./pages/Login";
import ProductAdd from "./pages/ProductAdd";
import ProductList from "./pages/ProductList";
import QuestionAdd from "./pages/QuestionAdd";
import QuestionList from "./pages/QuestionList";
import RoleAdd from "./pages/RoleAdd";
import RoleList from "./pages/RoleList";
import StoreAdd from "./pages/StoreAdd";
import StoreList from "./pages/StoreList";
import Tickets from "./pages/Tickets";
import { ToastContainer } from "react-toastify";
import UserAdd from "./pages/UserAdd";
import UserList from "./pages/UserList";
import { locationPath } from "./constants/appRoutes";
import { securityActions } from "./reducers/security";
import store from "./reducers";
import { useSelector } from "react-redux";
import TaskList from "./pages/TaskList";
import TaskAdd from "./pages/TaskAdd";
import OrderList from "./pages/OrderList";
import OrderDetail from "./pages/OrderDetail";
import TaskDetail from "./pages/TaskDetail";
import NotificationAdd from "./pages/NotificationAdd";
import NotificationList from "./pages/NotificationList";
import NotificationSystemList from "./pages/NotificationSystemList";
import NotificationSystemAdd from "./pages/NotificationSystemAdd";
import Chat from "./pages/Chat";

//login

//pages

//css

const token = localStorage.getItem("token_value");
const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));

if (token) {
  store.dispatch(securityActions.setCurrentUser(loggedUser));
}

function App() {
  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);

  const isAuthenticated = loggedUserReducer?.loggedUser?.token;

  return (
    <AuthContext.Provider
      value={{
        ...loggedUserReducer,
      }}
    >
      <Routes>
        {isAuthenticated ? (
          <Route
            exact
            path={"/"}
            element={<AdminRoute component={Dashboard} />}
          ></Route>
        ) : (
          <Route path="/" element={<Login />} />
        )}

        <Route
          exact
          path={locationPath.DASHBOARD}
          element={<AdminRoute component={Dashboard} />}
        ></Route>

        <Route
          exact
          path={"/company-list"}
          element={<AdminRoute component={CompanyList} />}
        ></Route>
        <Route
          exact
          path={"/company-add"}
          element={<AdminRoute component={CompanyAdd} />}
        ></Route>
        <Route
          exact
          path={"/company-edit/:id"}
          element={<AdminRoute component={CompanyAdd} />}
        ></Route>

        <Route
          exact
          path={"/product-category-list"}
          element={<AdminRoute component={CategoryProductList} />}
        ></Route>
        <Route
          exact
          path={"/product-category-add"}
          element={<AdminRoute component={CategoryProductAdd} />}
        ></Route>
        <Route
          exact
          path={"/productCategory-edit/:id"}
          element={<AdminRoute component={CategoryProductAdd} />}
        ></Route>

        <Route
          exact
          path={"/product-list"}
          element={<AdminRoute component={ProductList} />}
        ></Route>
        <Route
          exact
          path={"/product-add"}
          element={<AdminRoute component={ProductAdd} />}
        ></Route>
        <Route
          exact
          path={"/product-edit/:id"}
          element={<AdminRoute component={ProductAdd} />}
        ></Route>

        <Route
          exact
          path={"/blog-list"}
          element={<AdminRoute component={BlogList} />}
        ></Route>
        <Route
          exact
          path={"/blog-add"}
          element={<AdminRoute component={BlogAdd} />}
        ></Route>
        <Route
          exact
          path={"/blog-edit/:id"}
          element={<AdminRoute component={BlogAdd} />}
        ></Route>

        <Route
          exact
          path={"/education-list"}
          element={<AdminRoute component={EducationList} />}
        ></Route>
        <Route
          exact
          path={"/education-add"}
          element={<AdminRoute component={EducationAdd} />}
        ></Route>
        <Route
          exact
          path={"/education-edit/:id"}
          element={<AdminRoute component={EducationAdd} />}
        ></Route>

        <Route
          exact
          path={"/promotion-list"}
          element={<AdminRoute component={PromotionList} />}
        ></Route>
        <Route
          exact
          path={"/promotion-add"}
          element={<AdminRoute component={PromotionAdd} />}
        ></Route>
        <Route
          exact
          path={"/promotion-edit/:id"}
          element={<AdminRoute component={PromotionAdd} />}
        ></Route>

        <Route
          exact
          path={"/task-list"}
          element={<AdminRoute component={TaskList} />}
        ></Route>
        <Route
          exact
          path={"/task-detail/:id"}
          element={<AdminRoute component={TaskDetail} />}
        ></Route>
        <Route
          exact
          path={"/task-add"}
          element={<AdminRoute component={TaskAdd} />}
        ></Route>
        <Route
          exact
          path={"/task-edit/:id"}
          element={<AdminRoute component={TaskAdd} />}
        ></Route>

        <Route
          exact
          path={"/lesson-list"}
          element={<AdminRoute component={LessonList} />}
        ></Route>
        <Route
          exact
          path={"/lesson-add"}
          element={<AdminRoute component={LessonAdd} />}
        ></Route>
        <Route
          exact
          path={"/lesson-edit/:id"}
          element={<AdminRoute component={LessonAdd} />}
        ></Route>

        <Route
          exact
          path={"/question-list"}
          element={<AdminRoute component={QuestionList} />}
        ></Route>
        <Route
          exact
          path={"/question-add"}
          element={<AdminRoute component={QuestionAdd} />}
        ></Route>
        <Route
          exact
          path={"/question-edit/:id"}
          element={<AdminRoute component={QuestionAdd} />}
        ></Route>

        <Route
          exact
          path={"/education-category-list"}
          element={<AdminRoute component={EducationCategoryList} />}
        ></Route>
        <Route
          exact
          path={"/education-category-add"}
          element={<AdminRoute component={EducationCategoryAdd} />}
        ></Route>
        <Route
          exact
          path={"/education-category-edit/:id"}
          element={<AdminRoute component={EducationCategoryAdd} />}
        ></Route>

        <Route
          exact
          path={"/award-order"}
          element={<AdminRoute component={AwardOrder} />}
        ></Route>
        <Route
          exact
          path={"/award-list"}
          element={<AdminRoute component={AwardList} />}
        ></Route>
        <Route
          exact
          path={"/award-add"}
          element={<AdminRoute component={AwardAdd} />}
        ></Route>
        <Route
          exact
          path={"/award-edit/:id"}
          element={<AdminRoute component={AwardAdd} />}
        ></Route>

        <Route
          exact
          path={"/gallery-list"}
          element={<AdminRoute component={GalleryList} />}
        ></Route>
        <Route
          exact
          path={"/gallery-add"}
          element={<AdminRoute component={GalleryAdd} />}
        ></Route>

        <Route
          exact
          path={"/store-list"}
          element={<AdminRoute component={StoreList} />}
        ></Route>
        <Route
          exact
          path={"/store-add"}
          element={<AdminRoute component={StoreAdd} />}
        ></Route>
        <Route
          exact
          path={"/store-edit/:id"}
          element={<AdminRoute component={StoreAdd} />}
        ></Route>

        <Route
          exact
          path={"/country-list"}
          element={<AdminRoute component={CountryList} />}
        ></Route>
        <Route
          exact
          path={"/country-add"}
          element={<AdminRoute component={CountryAdd} />}
        ></Route>
        <Route
          exact
          path={"/country-edit/:id"}
          element={<AdminRoute component={CountryAdd} />}
        ></Route>

        <Route
          exact
          path={"/user-list"}
          element={<AdminRoute component={UserList} />}
        ></Route>
        <Route
          exact
          path={"/user-add"}
          element={<AdminRoute component={UserAdd} />}
        ></Route>
        <Route
          exact
          path={"/user-edit/:id"}
          element={<AdminRoute component={UserAdd} />}
        ></Route>

        <Route
          exact
          path={"/role-list"}
          element={<AdminRoute component={RoleList} />}
        ></Route>
        <Route
          exact
          path={"/role-add"}
          element={<AdminRoute component={RoleAdd} />}
        ></Route>
        <Route
          exact
          path={"/role-edit/:id"}
          element={<AdminRoute component={RoleAdd} />}
        ></Route>

        <Route
          exact
          path={"/level-list"}
          element={<AdminRoute component={LevelList} />}
        ></Route>
        <Route
          exact
          path={"/level-add"}
          element={<AdminRoute component={LevelAdd} />}
        ></Route>
        <Route
          exact
          path={"/level-edit/:id"}
          element={<AdminRoute component={LevelAdd} />}
        ></Route>

        <Route
          exact
          path={"/customer-list"}
          element={<AdminRoute component={CustomerList} />}
        ></Route>

        <Route
          exact
          path={"/notification-list"}
          element={<AdminRoute component={NotificationList} />}
        ></Route>
        <Route
          exact
          path={"/notification-add"}
          element={<AdminRoute component={NotificationAdd} />}
        ></Route>
        <Route
          exact
          path={"/notification-edit/:id"}
          element={<AdminRoute component={NotificationAdd} />}
        ></Route>

        <Route
          exact
          path={"/notification-list-system"}
          element={<AdminRoute component={NotificationSystemList} />}
        ></Route>
        <Route
          exact
          path={"/notification-edit-system/:id"}
          element={<AdminRoute component={NotificationSystemAdd} />}
        ></Route>
        <Route
          exact
          path={"/customer-edit/:id"}
          element={<AdminRoute component={CustomerAdd} />}
        ></Route>

        <Route
          exact
          path={"/tickets"}
          element={<AdminRoute component={Tickets} />}
        ></Route>
        <Route
          exact
          path={"/order"}
          element={<AdminRoute component={OrderList} />}
        ></Route>
        <Route
          exact
          path={"/order-detail/:id"}
          element={<AdminRoute component={OrderDetail} />}
        ></Route>
        <Route
          exact
          path={"/chat"}
          element={<AdminRoute component={Chat} />}
        ></Route>

        <Route path="*" element={<AdminRoute component={ErrorPage} />} />
      </Routes>
      <ToastContainer />
    </AuthContext.Provider>
  );
}

export default App;
